import { section3Data } from './data/section3Data'
import { OurValuesItemDesktop } from './OurValuesItemDesktop'
import { OurValuesItemMobile } from './OurValuesItemMobile'

export const Section3 = () => {
  return (
    <>
      <div className='lg:hidden flex flex-col items-center pt-10'>
        {section3Data.map((item, index) => (
          <OurValuesItemMobile
            key={index}
            index={index}
            bgColor={item.bgColor}
            title={item.title}
            titleTextColor={item.titleTextColor}
            description={item.description}
          />
        ))}
      </div>
      <div className='hidden lg:flex flex-row items-center justify-center pt-10'>
        {section3Data.map((item, index) => (
          <OurValuesItemDesktop
            key={index}
            index={index}
            bgColor={item.bgColor}
            title={item.title}
            titleTextColor={item.titleTextColor}
            description={item.description}
          />
        ))}
      </div>
    </>
  )
}
